<template>
  <div id="indicador-percepcao-compra" class="pl-5 mr-5 mt-3">
    <fullscreen
      class="pa-2 ma-2"
      background="#FFF"
      ref="fullscreen"
      @change="fullscreenChange"
    >
      <div id="filtros" class="mb-4">
        <v-row>
          <v-col cols="3">
            <v-row>
              <h2>Status produtos</h2>

              <button
                title="Modo de Apresentação"
                type="button"
                @click="toggle"
              >
                <v-icon
                  large
                  class="mdi"
                  :class="[fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen']"
                ></v-icon>
              </button>
            </v-row>
          </v-col>


          <v-col cols="9">
            <v-row>
              <v-spacer></v-spacer>

              <v-col class="pa-0">
                <sys-comprador
                  v-model="filtros.compradores"
                  label="Filtro de Compradores"
                  style="width: 300px;"
                  dense
                  outlined
                  height="10"
                  hide-details
                  multiple
                  clearable
                  :ocultarTodos="true"
                  :qtde_visivel_selecionados="1"
                  @update:modelValue="buscarIndicadorStatusProdutos();"
                ></sys-comprador>
              </v-col>

              <v-col class="pa-0">
                <sys-segmento
                  v-model="filtros.segmentos"
                  label="Filtro de Segmentos"
                  style="width: 300px;"
                  class="mx-2"
                  dense
                  outlined
                  hide-details
                  multiple
                  clearable
                  height="10"
                  :ocultarTodos="true"
                  :disabled="loading.segmentos"
                  :qtde-visivel-selecionados="1"
                  @update:modelValue="buscarIndicadorStatusProdutos();"
                ></sys-segmento>
              </v-col>

              <v-col class="pa-0">
                <sys-fornecedor
                  v-model="filtros.fornecedores"
                  label="Selecione o Fornecedor"
                  style="width: 300px;"
                  outlined
                  hide-details
                  dense
                  multiple
                  clearable
                  height="10"
                  :ocultarTodos="true"
                  :disabled="loading.fornecedores"
                  :qtde-visivel-selecionados="1"
                  :idSegmento="filtros.segmentos"
                  @update:modelValue="buscarIndicadorStatusProdutos();"
                ></sys-fornecedor>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <div id="graficos">
        <div style="width: 104%" class="ml-n7">
          <chart-pilha
            :categorias="itemsGrafico"
            :dados="itemsGrid"
            id="grafico-empilhado"
            :cores="cores"
          ></chart-pilha>
        </div>
      </div>

      <div id="grid" style="width: 102%" class="ml-n4 mt-0">
        <v-simple-table class="simple-table-indicadores" dense>
          <template v-slot:default>
            <tbody>
              <tr v-if="oldItemsGrid[tipo_selecionado]">
                <td
                  class="font-weight-bold pl-2"
                  style="background-color: gray"
                >
                  <v-btn
                    icon
                    small
                    color="#FFF"
                    class="my-1"
                    disabled
                  >
                    <v-icon>mdi-arrange-send-backward</v-icon>
                  </v-btn>
                </td>

                <td
                  v-for="(item, index) in oldItemsGrid[tipo_selecionado]"
                  :key="index"
                  class="font-weight-bold"
                  style="text-align: center; cursor: pointer; background-color: gray;"
                >
                  <span class="mx-auto">{{ calculoPercentagem(item, index, true) }}%</span>
                </td>
              </tr>

              <tr v-for="key in Object.keys(itemsGrid)" :key="key">
                <td class="font-weight-bold pl-3">
                  <v-btn
                    icon
                    small
                    color="#FFF"
                    class="my-1"
                    :style="`background: ${cores[key]}`"
                    :title="converterTitulo(key)"
                    @click="statusProdutoGrid(key)"
                  >
                    <v-icon v-if="btnGrid">mdi-chevron-left</v-icon>
                    <v-icon v-else>mdi-chevron-right</v-icon>
                  </v-btn>
                </td>

                <td
                  v-for="(item, index) in itemsGrid[key]"
                  :key="index"
                  :style="`width: ${tamanhoCol(itemsGrid[key])}`"
                  style="text-align: center; cursor: pointer"
                  @click="abrirDialog(index, key)"
                >
                  <span class="mx-auto">{{ calculoPercentagem(item, index) }}%</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- ABRE O DIALOG DE EXPORTAÇÃO DE RELATORIOS -->
      <div id="dialog-status-produtos">
        <dialog-status-produtos
          v-model="statusDialog"
          :dados="dadosDialog"
          :idfornecedor="filtros.fornecedores"
          :idsegmento="filtros.segmentos"
          :idcomprador="filtros.compradores"
          :selecionadoGrid="btnGrid"
          :parametros_dialog="parametros_dialog"
        ></dialog-status-produtos>
      </div>
    </fullscreen>
  </div>
</template>

<script>
import IndicadoresAPI from "./../../../api/indicadores";
import chartPilha from "./ChartStatusProdutos";
import dialogStatusProdutos from "./DialogStatusProduto.vue";
import { mapGetters } from "vuex";

import SysComprador from "../../utils/crud/SysCompradorAutocomplete.vue";
import SysSegmento from "../../utils/crud/SysSegmentoAutocomplete.vue";
import SysFornecedor from "../../utils/crud/SysFornecedorAutocomplete.vue";

export default {
  components: {
    chartPilha,
    dialogStatusProdutos,
    SysSegmento,
    SysFornecedor,
    SysComprador
  },
  data: () => ({
    fullscreen: false,
    filtros: {
      segmentos: [0],
      fornecedores: [],
      compradores: [],
    },
    loading: {
      segmentos: true,
      fornecedores: true,
      compradores: true,
    },
    selects: {
      segmentos: {
        items: [],
      },
      fornecedores: {
        items: [],
      },
    },
    cores: {
      ruptura: "rgba(253, 0, 1, 1)",
      excesso: "rgba(4, 35, 51, 0.9)",
      adequado: "rgba(0, 174, 81, 1)",
      elevada_exposicao_ruptura: "rgba(255, 191, 5, 1)",
      baixa_exposicao_ruptura: "rgba(255, 254, 2, 1)",
      // ruptura: "#FF0000",
      // elevada_exposicao_ruptura: "#FFFF00",
      // baixa_exposicao_ruptura: "#0000FF",
      // adequado: "#008000",
      // excesso: "#363636",
      ruptura_com_pedido: "rgba(253, 0, 1, 1)",
      ruptura_sem_pedido: "rgba(253, 0, 1, 0.3)",
      elevada_exposicao_ruptura_com_pedido: "rgba(255, 191, 5, 1)",
      elevada_exposicao_ruptura_sem_pedido: "rgba(255, 191, 5, 0.4)",
      baixa_exposicao_ruptura_com_pedido: "rgba(255, 254, 2, 1)",
      baixa_exposicao_ruptura_sem_pedido: "rgba(255, 154, 2, 0.4)",
      adequado_com_pedido: "rgba(0, 174, 81, 1)",
      adequado_sem_pedido: "rgba(0, 174, 81, 0.5)",
      excesso_com_pedido: "rgba(4, 35, 51, 1)",
      excesso_sem_pedido: "rgba(4, 35, 51, 0.7)",
    },
    itemsGrid: [],
    itemsGrafico: [],
    statusDialog: false,
    dadosDialog: [],
    oldItemsGrid: [],
    oldItemsGrafico: [],
    btnGrid: false,
    tipo_selecionado: "",
    parametros_dialog: {}
  }),

  created() {
    this.buscarIndicadorStatusProdutos();
    this.buscarDadosFiltros()
    this.addGrupoTodos();
  },

  updated() {
    this.addGrupoTodos();
  },

  computed: {
    ...mapGetters({
      grupos: "usuario/getGrupos",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras"
    }),
  },

  watch: {
    grupoCompra() {
      this.buscarIndicadorStatusProdutos();
      this.buscarDadosFiltros();
    },

    filialCompra() {
      this.buscarIndicadorStatusProdutos();
    },
  },

  methods: {
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },

    toggle() {
      this.$refs["fullscreen"].toggle();
    },

    removerTodos(event) {
      if(this.filtros.fornecedores.length > 1) {
        this.filtros.fornecedores.forEach((item, i) => {
          if(item==0){
            this.filtros.fornecedores.splice(i, 1);
          }
        });
      }

      if(this.filtros.segmentos.length > 1) {
        this.filtros.segmentos.forEach((item, i) => {
          if(item==0){
            this.filtros.segmentos.splice(i, 1);
          }
        });
      }
    },

    abrirDialog(mesAno, tipo) {
      this.parametros_dialog = {
        grupo: this.grupoCompra,
        filial: this.filialCompra,
        periodo: mesAno + '-01',
        status: tipo,
        fornecedores: this.filtros.fornecedores,
        segmentos: this.filtros.segmentos,
        compradores: this.filtros.compradores,
        selecionado_grid: this.btnGrid
      }

      this.statusDialog = true;

      // const headers = this.Helpers.iniciarRequisicao();

      // const params = {
      //   grupo: this.grupoCompra,
      //   filial: this.filialCompra,
      //   periodo: mesAno + '-01',
      //   status: tipo,
      //   fornecedores: this.filtros.fornecedores,
      //   segmentos: this.filtros.segmentos,
      //   compradores: this.filtros.compradores,
      //   selecionado_grid: this.btnGrid
      // };

      // this.$store.dispatch(
      //   "loading/addRequisicao",
      //   IndicadoresAPI.getDialogIndicadorStatusProdutos(headers, params)
      //     .then((response) => {
      //       const { token, dados_dialog } = response.data;
      //       localStorage.setItem("token", token);

      //       this.statusDialog = true;
      //       this.dadosDialog = {
      //         dadosDesserts: dados_dialog,
      //         dadosDialog: params
      //       };
      //     })
      //     .catch(() => {
      //       this.Helpers.logout();
      //     })
      // );
    },

    addGrupoTodos() {
      let existeGrupoTodos = false;

      this.grupos.forEach((g) => {
        if (g.id == 0) existeGrupoTodos = true;
      });

      if (!existeGrupoTodos) {
        const objGrupo = {
          id: 0,
          descricao: "Todos Grupos",
          sigla: "TDS",
        };

        this.grupos.push(objGrupo);

        this.$store.dispatch("usuario/setGrupos", this.grupos);
        this.ativarExibicaoFilial();
      }
    },

    ativarExibicaoFilial() {
      this.$store.dispatch("usuario/setExibeFilialCompra", true);
    },

    idsFornecedoresSelecionados(){
      return this.filtros.fornecedores.filter(com => com > 0);
    },

    idsSegmentosSelecionados(){
      return this.filtros.segmentos.filter(com => com > 0);
    },

    buscarDadosFiltros() {
      if (this.grupoCompra) {
        const headers = this.Helpers.iniciarRequisicao();

        this.loading.segmentos = true;
        this.loading.fornecedores = true;

        const params = {
          grupo: this.grupoCompra,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          IndicadoresAPI.getDadosFiltrosIndicadorStatusProdutos(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.loading.fornecedores = false;
              this.selects.fornecedores.items = response.data.filtros.fornecedores;
              const OBJFORN = {
                idfornecedor: 0,
                razao_social: "Todos",
                fornecedor: "Todos",
              };
              this.selects.fornecedores.items.unshift(OBJFORN);

              this.loading.segmentos = false;
              this.selects.segmentos.items = response.data.filtros.segmentos;
              const OBJSEG = {
                idfamilia_produto: 0,
                descricao_familia_produto: "Todos",
                segmento: "Todos",
              };
              this.selects.segmentos.items.unshift(OBJSEG);
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    statusProdutoGrid(tipo) {
      this.btnGrid = !this.btnGrid;

      if (this.btnGrid) {
        this.tipo_selecionado = tipo;

        this.oldItemsGrid = this.itemsGrid;
        this.oldItemsGrafico = this.itemsGrafico;

        this.itemsGrid = [];
        this.itemsGrafico = [];

        const headers = this.Helpers.iniciarRequisicao();
        const params = {
          grupo: this.grupoCompra,
          filial: this.filialCompra,
          fornecedores: this.filtros.fornecedores,
          segmentos: this.filtros.segmentos,
          compradores: this.filtros.compradores,
          tipo: tipo
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          IndicadoresAPI.getIndicadorStatusProdutosGrid(headers, params)
            .then((response) => {
              const { token, dados, grafico } = response.data;
              localStorage.setItem("token", token);

              this.itemsGrid = dados;
              this.itemsGrafico = grafico;
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        this.tipo_selecionado = "";

        this.itemsGrid = this.oldItemsGrid;
        this.itemsGrafico = this.oldItemsGrafico;

        this.oldItemsGrid = [];
        this.oldItemsGrafico = [];
      }
    },

    buscarIndicadorStatusProdutos() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        filial: this.filialCompra,
        fornecedores: this.filtros.fornecedores,
        segmentos: this.filtros.segmentos,
        compradores: this.filtros.compradores,
        selecionado_grid: this.btnGrid
      };

      if (this.btnGrid) {
        this.btnGrid = false;

        this.itemsGrid = [];
        this.itemsGrafico = [];

        this.oldItemsGrid = [];
        this.oldItemsGrafico = [];
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        IndicadoresAPI.getIndicadorStatusProdutos(headers, params)
          .then((response) => {
            const { token, dados, grafico } = response.data;
            localStorage.setItem("token", token);

            this.itemsGrid = dados;
            this.itemsGrafico = grafico;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    calculoPercentagem(item, index, old = false) {
      let percentual = 0;

      if (item != 0 && index != 0 && old) {
        percentual = (item / this.oldItemsGrafico[index]) * 100;
      } else if (item != 0 && index != 0){
        percentual = (item / this.itemsGrafico[index]) * 100;
      }

      return this.Helpers.formatarValorComCasas(percentual, 2);
    },

    tamanhoCol(array) {
      return 100 / Object.values(array).length + "%";
    },

    converterTitulo(string) {
      let array = string.split("_");

      array[0] = array[0].charAt(0).toUpperCase() + array[0].substr(1);

      return this.btnGrid ? "Voltar para o início" : `Visualizar status "${array.join(' ')}", com e sem pedido detalhadamente`;
    }
  },
};
</script>

<style scoped>
  #graficos {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }

  #grid {
    margin-top: 10px;
    margin-left: -2px;
    margin-right: -2px;
  }

  #grafico-empilhado {
    height: calc(100vh - 330px) !important;
  }
</style>
